import setFieldValue from "@iewccouk/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@iewccouk/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewccouk/Widgets/RfqRequestQuote/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.textFields,
};

const mapStateToProps = (state: CustomState) => ({
    lastName: state.customRequestQuoteForm.fieldValues.lastName,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const LastNameWidget: React.FC<Props> = ({ fields: widgetFields, lastName, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired } = widgetFields;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, lastName, "lastName", () =>
        validateFieldBy(isRequired, label, lastName, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "lastName", value: event.target.value });
    };

    return (
        <>
            <TextField
                {...styles}
                label={label}
                required={isRequired}
                placeholder={hintText}
                value={lastName || ""}
                error={fieldErrorMessage}
                onChange={fieldChangeHandler}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(LastNameWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            getRfqFormLabelBuilt("Last Name"),
            getRfqFormHintTextBuilt("Enter Last Name"),
            getRfqFormCheckboxBuilt(),
        ],
    },
};

export default widgetModule;
